export function compareTime(startTime, endTime) {
  let start = new Date(startTime).getTime()
  let end = new Date(endTime).getTime()
  let result = (end - start) / 3600 / 1000
  if (parseInt(result) <= 0) {
    return true
  } else { return false }
}

/**
 * @param {*} startTime MM-mm-dd HH:mm:ss
 * @param {*} endTime MM-mm-dd HH:mm:ss
 * @returns Boolean
 */
 export function compareTimeStan(startTime, endTime) {
  const start = startTime.replace(/-/g, '/')
  const end = endTime.replace(/-/g, '/')
  const result = (Date.parse(end) - Date.parse(start)) / 3600 / 1000
  if (result <= 0) {
    return true
  } else { return false }
}

/**
 * @param {*} time MM-mm-dd HH:mm:ss
 * @returns 毫秒
 */
 export function timeToSc(time) {
  const times = time.replace(/-/g, '/')
  return (Date.parse(times)) / 3600 / 1000
}